/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LixiApplicationResponseBaseResponse as ModelsV3ApplicationLixiApplicationResponseBaseResponse } from '../models/Models/v3/Application/lixi-application-response-base-response';
import { v3ApplicationDealerportalGet } from '../fn/application/v-3-application-dealerportal-get';
import { V3ApplicationDealerportalGet$Params } from '../fn/application/v-3-application-dealerportal-get';
import { v3ApplicationLixiProductUuidPost$Json } from '../fn/application/v-3-application-lixi-product-uuid-post-json';
import { V3ApplicationLixiProductUuidPost$Json$Params } from '../fn/application/v-3-application-lixi-product-uuid-post-json';
import { v3ApplicationLixiProductUuidPost$Plain } from '../fn/application/v-3-application-lixi-product-uuid-post-plain';
import { V3ApplicationLixiProductUuidPost$Plain$Params } from '../fn/application/v-3-application-lixi-product-uuid-post-plain';
import { v3ApplicationLixiProductUuidPost$Xml } from '../fn/application/v-3-application-lixi-product-uuid-post-xml';
import { V3ApplicationLixiProductUuidPost$Xml$Params } from '../fn/application/v-3-application-lixi-product-uuid-post-xml';

@Injectable({ providedIn: 'root' })
export class ApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3ApplicationLixiProductUuidPost()` */
  static readonly V3ApplicationLixiProductUuidPostPath = '/v3/application/lixi/{product}/{uuid}';

  /**
   * Submits new application via the LIXI xml format.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationLixiProductUuidPost$Plain()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  v3ApplicationLixiProductUuidPost$Plain$Response(params: V3ApplicationLixiProductUuidPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationLixiApplicationResponseBaseResponse>> {
    return v3ApplicationLixiProductUuidPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Submits new application via the LIXI xml format.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationLixiProductUuidPost$Plain$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  v3ApplicationLixiProductUuidPost$Plain(params: V3ApplicationLixiProductUuidPost$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationLixiApplicationResponseBaseResponse> {
    return this.v3ApplicationLixiProductUuidPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationLixiApplicationResponseBaseResponse>): ModelsV3ApplicationLixiApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Submits new application via the LIXI xml format.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationLixiProductUuidPost$Json()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  v3ApplicationLixiProductUuidPost$Json$Response(params: V3ApplicationLixiProductUuidPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationLixiApplicationResponseBaseResponse>> {
    return v3ApplicationLixiProductUuidPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Submits new application via the LIXI xml format.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationLixiProductUuidPost$Json$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  v3ApplicationLixiProductUuidPost$Json(params: V3ApplicationLixiProductUuidPost$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationLixiApplicationResponseBaseResponse> {
    return this.v3ApplicationLixiProductUuidPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationLixiApplicationResponseBaseResponse>): ModelsV3ApplicationLixiApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Submits new application via the LIXI xml format.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationLixiProductUuidPost$Xml()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  v3ApplicationLixiProductUuidPost$Xml$Response(params: V3ApplicationLixiProductUuidPost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationLixiApplicationResponseBaseResponse>> {
    return v3ApplicationLixiProductUuidPost$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Submits new application via the LIXI xml format.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationLixiProductUuidPost$Xml$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  v3ApplicationLixiProductUuidPost$Xml(params: V3ApplicationLixiProductUuidPost$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationLixiApplicationResponseBaseResponse> {
    return this.v3ApplicationLixiProductUuidPost$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationLixiApplicationResponseBaseResponse>): ModelsV3ApplicationLixiApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationDealerportalGet()` */
  static readonly V3ApplicationDealerportalGetPath = '/v3/application/dealerportal';

  /**
   * Get the dealer portal url.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationDealerportalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationDealerportalGet$Response(params?: V3ApplicationDealerportalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v3ApplicationDealerportalGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the dealer portal url.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationDealerportalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ApplicationDealerportalGet(params?: V3ApplicationDealerportalGet$Params, context?: HttpContext): Observable<void> {
    return this.v3ApplicationDealerportalGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
